<template>
  <div class="row breadcrumb-wrapper">
    <div class="col-12">
      <ul class="breadcrumb" v-if="menuList">
        <li v-for="(nav, index) in menuDisplayList" :key="index">
          <template v-if="nav.link">
            <span><router-link :to="nav.link">{{ nav.title }}</router-link></span>
          </template>
          <template v-else>
            <span>{{ nav.title }}</span>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Breadcrumb',
  props: {
    menuList: {
      type: Array,
      // default: [],
    }
  },
  computed: {
    menuDisplayList() {
      let menu = [
        {
          link: { name: 'home' },
          title: 'トップページ',
        },
      ];
      if (this.menuList && this.menuList.length > 0) {
        for(let i = 0; i < this.menuList.length; i++) {
          menu.push(this.menuList[i]);
        }
      } else {
        return [];
      }
      return menu;
    }
  }
}
</script>

<style scoped lang="scss">
.breadcrumb-wrapper {
  margin-bottom: 20px;
}
ul.breadcrumb {
  li {

  }
  li + li:before {
    content: "|";
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
